module.exports = __webpack_public_path__ + "img/home_image_banner@2x_03.800ec767.png";